import * as React from 'react';

import Redo16 from './Redo16';

export const redo16 = () => <Redo16 />;

export default {
    title: 'Icon/Line/Redo16',
    component: Redo16,
    parameters: {
        notes: "`import Redo16 from 'box-ui-elements/es/icon/line/Redo16';`",
    },
};
